import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row  , Modal} from "react-bootstrap";

import { Link, useNavigate, useParams } from "react-router-dom";

// img
import d1 from "../../../../Assets/images/doc.png";
import { useDispatch, useSelector } from "react-redux";
import { getAgencyView, getAgencies } from "../../../../store/agency/actions";
import TableProfile from "../../../../components/Common/TableProfile";
import Slider from "react-slick";
import moment from "moment";
import { APPROVING_AGENCY } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";

const AgencyView = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const approveDriverHandler = async (item, status) => {
    try {
      const res = await APPROVING_AGENCY({ providerId: id, status });
      if (res.data.status === "success") {
        toast.success(res.data.message);
        dispatch(getAgencies(body, "new_request"));
        navigate("/manage-agency/agency-request");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const agencyDetail = useSelector((s) => s?.agency?.agencyListData);
  console.log(agencyDetail, "ssssssss");
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (id) {
      dispatch(getAgencyView(id));
    }
  }, []);

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    if (body.search.trim() === "")
      dispatch(getAgencies(newbody, "new_request"));
  }, [body.search]);

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    dispatch(getAgencies(newbody, "new_request"));
  }, [body.status, body.limit]);

  return (
    <>
      <section className="AgencyDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-start">
            <Col lg="12" className="my-2">
              <Link to="/manage-agency/agency-request" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>

            <Row>
              {/* <h5 className="d-flex justify-content-end">Approve</h5> */}
              <Col lg="12" className="d-flex justify-content-end">
                <div className="ActnBtn gap-10 d-flex align-items-center ">
                  <h5 className="fw-sbold themeBlue">Approve</h5>
                  {/* {item.status == "created" ? (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
                <path
                  d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                  fill="white"
                />
                <path
                  d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                  fill="white"
                />
              </svg>
            </>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
              >
                <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
                <path
                  d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                  fill="white"
                />
                <path
                  d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                  fill="white"
                />
              </svg>
            </>
          )} */}
                  {/* {item.request == "approve" ? ( */}
                  <>
                    <svg
                      onClick={(item) => approveDriverHandler(item, "rejected")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
                      <path
                        d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                        fill="white"
                      />
                      <path
                        d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                        fill="white"
                      />
                    </svg>
                  </>
                  {/* ) : ( */}
                  <>
                    <svg
                      onClick={(item) => approveDriverHandler(item, "approved")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
                      <path
                        d="M24.4699 11.2886C23.7596 10.5783 22.6097 10.5783 21.8994 11.2886L13.2104 19.9776L10.1019 16.8691C9.39159 16.1588 8.23821 16.1588 7.53142 16.8691C6.82462 17.5794 6.8211 18.7328 7.53142 19.4396L11.9269 23.8351C12.6372 24.5454 13.7871 24.5454 14.4974 23.8351L24.4699 13.8591C25.1767 13.1488 25.1767 11.9989 24.4699 11.2886Z"
                        fill="white"
                      />
                    </svg>
                  </>
                  {/* )} */}
                </div>
              </Col>
            </Row>
            <Row lg={12} className="justify-content-start">
              <Col lg="6" className="my-2">
                <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                  Agency Details:
                </h5>
                <div className="cardCstm border rounded px-3 py-2">
                  <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                    <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                      <span className="w-50 text-muted fw-sbold">
                        Agency Name:
                      </span>
                      <p className="m-0 text-danger w-50 fw-sbold">
                        {agencyDetail?.[0]?.name}
                      </p>
                    </li>
                    <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                      <span className="w-50 text-muted fw-sbold">
                        Phone Number:
                      </span>
                      <p className="m-0 text-danger w-50 fw-sbold">
                        {agencyDetail?.[0]?.countryCode +
                          agencyDetail?.[0]?.mobileNumber}
                      </p>
                    </li>
                    <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                      <span className="w-50 text-muted fw-sbold">
                        Email ID:
                      </span>
                      <p className="m-0 text-danger w-50 fw-sbold">
                        {agencyDetail?.[0]?.email}
                      </p>
                    </li>
                    <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                      <span className="w-50 text-muted fw-sbold">Address:</span>
                      <p className="m-0 text-danger w-50 fw-sbold">
                        {agencyDetail?.[0]?.businessAddress}
                      </p>
                    </li>
                    <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                      <span className="w-50 text-muted fw-sbold">
                        Agency Type
                      </span>
                      <p className="m-0 text-danger w-50 fw-sbold">
                        {agencyDetail?.[0]?.type}
                      </p>
                    </li>
                  </ul>
                  {/* <Row> */}
                </div>
              </Col>

              <Col lg="6" className="my-2">
                <h5 className="m-0 pb-2 mt-4 fw-sbold themeBlue">Document</h5>
                <Slider {...settings}>
                  {agencyDetail?.[0]?.documentsList?.map((item) => {
                    const { image } = item;
                    return (
                      <div
                        //  className="cardCcstm text-center d-flex align-items-center justify-content-around border rounded p-3 gap-10 flex-auto"
                        className="cardCstm border text-center rounded px-3 py-2 d-flex justify-content-evenly align-items-center gap-10"
                      >
                        <div
                          className="imgWrp"
                          style={{
                            height: "13.5rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {/* <img
                            src={image || d1}
                            alt=""
                            // className="img-fluid object-fit-contain"
                            style={{ height: 100, height: 100 }}
                          /> */}
                          <img
                              src={image || d1}
                              alt="document"
                              className="img-fluid object-fit-contain"
                              style={{ height: 100, cursor: "pointer" }}
                              onClick={() => handleImageClick(image || d1)} 
                            />
                        </div>
                        <div className="content">
                          <p className="text-muted fw-sbold m-0">EIN Number:</p>
                          <p className="text-danger fw-sbold m-0">
                            {item?.number || "34234234234"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </Slider>

                {/* </Row> */}
              </Col>
              <Modal show={showModal} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Document Preview</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body className="text-center">
                    {selectedImage && (
                      <img
                        src={selectedImage}
                        alt="Document Preview"
                        className="img-fluid"
                        style={{ maxHeight: "500px" }}
                      />
                    )}
                  </Modal.Body>
                </Modal>
            </Row>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AgencyView;
